import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {MatIconModule} from "@angular/material/icon";
import {ButtonModule} from "../button/button.module";
import { FormPasswordComponent } from "./password.component";

@NgModule({
  declarations: [ FormPasswordComponent ],
  imports: [ CommonModule, TranslateModule, MatIconModule, ButtonModule ],
  exports: [ FormPasswordComponent ],
})
export class FormPasswordModule {}
